import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";

const useTrackPageVist = (page, userEmail) => {
  const location = useLocation();

  useEffect(() => {
    if (window.location.hostname === "app-dev.citizengo.org") return;
    if (!userEmail || userEmail === false) return;

    const payload = {
      email: userEmail,
      eventName: "Website visit",
      dataFields: {
        section: page,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      },
    };

    axios
      .post(process.env.REACT_APP_ITERABLE_TRACK_URL, payload, {
        headers: {
          "Content-Type": "application/json",
          "Api-Key": process.env.REACT_APP_ITERABLE_API_KEY,
        },
      })
      .catch((error) => {
        console.error("Error tracking page visit:", error);
      });
  }, [location.pathname, userEmail]);
};

export default useTrackPageVist;
